<template>
  <div>
    <!-- 店铺授权 -->
    <baseBreadcrumb :page="$t('message.storeAuthorization')" :menu="$t('message.customerManagement')"></baseBreadcrumb>
    <!-- 主体 -->
    <div class="body">
      <!-- 店铺仓库类型 -->
      <div class="storeTabs">
        <el-tabs v-model="datas.warehouse_type" type="card" @tab-click="handleWarehouseTypeChange">
          <el-tab-pane label="全部" name=""></el-tab-pane>
          <el-tab-pane label="Amazon" name="amazon"></el-tab-pane>
          <el-tab-pane label="Stockcrew" name="stockcrew"></el-tab-pane>
        </el-tabs>
      </div>
      <!-- 搜索 -->
      <div class="search">
        <div class="row">
          <!-- 客户ID -->
          <div class="item">
            <el-input v-model="datas.user" :placeholder="$t('message.userNameOrID')" clearable
              onfocus="this.select()"></el-input>
          </div>
          <!-- 店铺名 -->
          <div class="item">
            <el-input v-model="datas.shop_name" :placeholder="$t('message.shopName')" clearable
              onfocus="this.select()"></el-input>
          </div>
          <div class="btn">
            <!-- 搜索 -->
            <el-button type="primary" @click="search">
              {{ $t("message.search") }}
            </el-button>
            <!-- 重置 -->
            <el-button @click="reset">
              {{ $t("message.reset") }}
            </el-button>
          </div>
          <!-- 操作 -->
        </div>
      </div>
      <!-- 列表 -->
      <div class="table" v-if="show">
        <el-table :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }"
          :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%" ref="multipleTable" size="small"
          :max-height="tableautoheight">
          <!-- 客户ID -->
          <el-table-column align="center" label="NO" prop="rowNumber" width="50">
          </el-table-column>
          <!-- 客户信息 -->
          <el-table-column align="center" :label="$t('message.userInfo')">
            <template slot-scope="scope">
              <p>ID:{{ scope.row.user_id }}</p>
              <p>{{ scope.row.realname }}</p>
            </template>
          </el-table-column>
          <!-- 店铺类型 -->
          <el-table-column align="center" :label="$t('message.storeType')" prop="warehouse_type">
          </el-table-column>
          <!-- 店铺名 -->
          <el-table-column align="center" :label="$t('message.shopName')" prop="shop_name">
          </el-table-column>
          <!-- 授权店铺ID -->
          <el-table-column align="center" :label="$t('message.authorizedStoreId')" prop="selling_partner_id">
          </el-table-column>
          <!-- 店铺商品 -->
          <el-table-column align="center" :label="$t('message.storeProducts')" prop="inventory_count">
          </el-table-column>
          <!-- 补货链接数量 -->
          <el-table-column align="center" :label="$t('message.replenishmentLinkCount')" prop="replenishment_count">
          </el-table-column>
          <!-- 部门 -->
          <el-table-column align="center" :label="$t('message.department')" prop="department" width="80">
          </el-table-column>
          <!-- 业务员 -->
          <el-table-column align="center" :label="$t('message.salesman')" prop="y_name" width="80">
          </el-table-column>
          <!-- api订单数 -->
          <el-table-column align="center" :label="$t('message.apiOrderCount')" prop="order_count" width="80">
          </el-table-column>
          <!-- api订单最新时间 -->
          <el-table-column align="center" :label="$t('message.apiOrderLatestTime')" prop="last_order_time" width="80">
          </el-table-column>
          <!-- api配送单数 -->
          <el-table-column align="center" :label="$t('message.apiShippingOrderCount')" prop="porder_count" width="80">
          </el-table-column>
          <!-- api配送单最新时间 -->
          <el-table-column align="center" :label="$t('message.apiShippingOrderLatestTime')" prop="last_porder_time"
            width="80">
          </el-table-column>
          <!-- 店铺添加日期 -->
          <el-table-column align="center" :label="$t('message.storeAddedDate')" prop="created_at" width="80">
          </el-table-column>
          <!-- 店铺首次授权日期 -->
          <el-table-column align="center" :label="$t('message.storeFirstAuthorizationDate')" prop="accredit_at"
            width="80">
          </el-table-column>
          <!-- 商品更新日期 -->
          <el-table-column align="center" :label="$t('message.productUpdateDate')" prop="inventory_at" width="80">
          </el-table-column>
          <!-- 补货链接最新更新时间 -->
          <el-table-column align="center" :label="$t('message.replenishmentLinkLastUpdated')" prop="replenishment_at"
            width="80">
          </el-table-column>
          <!-- 操作 -->
          <el-table-column align="center" :label="$t('message.operation')">
            <template slot-scope="scope">
              <el-button type="primary" @click="shopAccreditCancel(scope.row.id)" v-if="isAuth(615)">{{
                $t('message.unbind') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[50, 100, 200, 500]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableautoheight: window.innerHeight > 700 ? window.innerHeight - 200 : 800,
      datas: {
        page: 1,
        pageSize: 50,
        shop_name: "",
        user: "",
        warehouse_type: "",
      },
      tableData: [],
      total: 0,
      show: true,
    };
  },
  created() {
    this.shopManageList()
  },
  methods: {
    handleWarehouseTypeChange() {
      this.datas.page = 1;
      this.shopManageList();
    },
    shopManageList() {
      this.$api.clienteleApi.shopManageList(this.datas).then((res) => {
        this.tableData = res.data.data;
        this.total = res.data.total;
      });
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.shopManageList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.shopManageList();
    },
    // 搜索
    search() {
      this.datas.page = 1
      this.shopManageList();
    },
    // 重置
    reset() {
     
      this.datas = {
        page: 1,
        pageSize: 50,
        shop_name: "",
        user: "",
        warehouse_type: '',
      };
      this.shopManageList();
    },
    // 整个框选择
    labelSelection(row, column) {
      if (column.className == "el-table-column--selection") {
        this.$refs.multipleTable.toggleRowSelection(row);
      }
    },
    shopAccreditCancel(shop_id) {
      this.$confirm(
        '是否确认解除绑定店铺ID，解除绑定后，对应的补货链接对应解除关联，客户无法进行查看',
        this.$t("message.prompt"),
        {
          // 确定
          confirmButtonText: this.$t("message.ok"),
          // 取消
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.clienteleApi.shopAccreditCancel({ shop_id }).then((res) => {
            this.$message.success(res.msg)
            this.shopManageList();
          });
        })
        .catch(() => { });
    },
  },
};
</script>

<style lang='scss' scoped>
.storeTabs {
  margin-bottom: 24px;

  /deep/ .el-tabs__header {
    margin-bottom: 0;
  }

  /deep/ .el-tabs__item {
    min-width: 120px;
    text-align: center;
  }
}

.search {
  margin-bottom: 24px;
  position: relative;

  .row {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 16px;

    .item {
      width: 180px;
      margin-right: 24px;
      margin-bottom: 10px;
    }
  }

  .operation {
    position: absolute;
    top: -85px;
    right: 0
  }
}

.advancedScreening {
  margin-bottom: 24px;
}

/deep/.el-textarea__inner {
  padding: 0;
  min-height: 100px !important;
}

/deep/.cell {
  padding: 0 5px;
}
</style>
